T.QRDownload = Class(
	/**
	 * @lends {T.QRDownload#}
	 */
	{
		__NAME: 'T.QRDownload',

		__construct() {
			this.node = mkE({
				tag: 'div',
				className: 'qr-download',
				els: [
					{
						tag: 'div',
						className: 'image',
					},
					{
						tag: 'div',
						className: 'text',
						text: D.Lang.get('qr-download.text')
					},
					{
						tag: 'div',
						className: 'buttons',
						els: [
							new T.Download()
						]
					}
				]
			});
		}
	},
	mkE.Base
);